module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/5m-e0060442512b51d9424e7d08d95924d0.jpg";